var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBenefitExhibition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_05"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 422",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8867_97207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.667 29.9152C49.667 25.1153 52.8403 22.749 56.7305 22.749H56.7753C60.6729 22.749 63.8387 25.1153 63.8387 29.8853",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.252 36.3096H72.2536",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.252 40.3686V32.0342C41.252 31.4781 41.4722 30.9448 41.8643 30.5516C42.2564 30.1584 42.7881 29.9375 43.3426 29.9375H70.1106C70.679 29.9375 71.224 30.1639 71.6259 30.567C72.0278 30.97 72.2536 31.5166 72.2536 32.0866V64.6004C72.2536 65.3034 71.9751 65.9777 71.4794 66.4748C70.9837 66.9719 70.3114 67.2512 69.6104 67.2512H45.1346",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.5619 52.2598V64.6303C48.5619 65.3254 48.2865 65.992 47.7964 66.4835C47.3063 66.975 46.6416 67.2511 45.9485 67.2511H22.7197C22.02 67.2492 21.3496 66.969 20.8555 66.4721C20.3614 65.9752 20.084 65.3021 20.084 64.6003V52.2598",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.1972 46.1719H49.4804C49.8567 46.1719 50.2175 46.3218 50.4836 46.5886C50.7496 46.8554 50.8991 47.2173 50.8991 47.5946V50.837C50.8991 51.2144 50.7496 51.5762 50.4836 51.8431C50.2175 52.1099 49.8567 52.2598 49.4804 52.2598H19.1657C18.7895 52.2598 18.4286 52.1099 18.1626 51.8431C17.8965 51.5762 17.7471 51.2144 17.7471 50.837V47.5946C17.7471 47.2173 17.8965 46.8554 18.1626 46.5886C18.4286 46.3218 18.7895 46.1719 19.1657 46.1719H32.4564",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.4561 52.2596V45.5576C32.4978 45.09 32.7125 44.655 33.058 44.3382C33.4034 44.0214 33.8546 43.8457 34.3227 43.8457C34.7908 43.8457 35.242 44.0214 35.5875 44.3382C35.9329 44.655 36.1476 45.09 36.1894 45.5576V52.2596",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.1341 46.1722C46.6429 43.424 45.0152 40.4063 42.4392 40.2565C39.7139 40.0992 37.1379 42.8324 36.0029 44.7494",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.5118 46.1722C22.003 43.424 23.6308 40.4063 26.1993 40.2565C28.9321 40.0992 31.5081 42.8324 32.643 44.7494",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8867_97207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 46,
    fill: "white",
    transform: "translate(17 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitExhibition);
export default __webpack_public_path__ + "static/media/icon__benefit-exhibition.3478df80e52c3298c8e2c53b5a515f80.svg";
export { ForwardRef as ReactComponent };